import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Field, FieldContent, FieldLabel } from "@/components/ui/field";
import { Spinner } from "@/components/ui/spinner";

import RuvixxDate from "components/RuvixxDate";
import { EM_DASH } from "routes/custom_tables/grid/cellHelpers";

const DetailRow = ({ label, children }) => (
  <Field orientation="vertical">
    <FieldLabel className="tw:text-muted-foreground">{label}</FieldLabel>
    <FieldContent className="tw:text-foreground tw:min-w-0 tw:break-words">
      {children ?? EM_DASH}
    </FieldContent>
  </Field>
);

const LeadOverview = ({ lead, isLoading }) => {
  if (isLoading || !lead) {
    return (
      <div className="tw:p-8 tw:text-center tw:text-muted-foreground">
        <Spinner />
      </div>
    );
  }

  const responses = lead.responses ?? [];

  return (
    <div className="tw:flex tw:w-full tw:max-w-7xl tw:flex-col tw:gap-4">
      <Card>
        <CardHeader>
          <CardTitle>Meta Information</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="tw:grid tw:grid-cols-1 tw:gap-5 tw:sm:grid-cols-2">
            <DetailRow label="Name">{lead.name}</DetailRow>
            <DetailRow label="Email">{lead.email}</DetailRow>
            <DetailRow label="Phone">{lead.phone}</DetailRow>
            <DetailRow label="Campaign">{lead.campaign_name}</DetailRow>
            <DetailRow label="Form">{lead.form_name}</DetailRow>
            <DetailRow label="Created">
              {lead.created_time ? (
                <RuvixxDate date={lead.created_time} />
              ) : null}
            </DetailRow>
            <DetailRow label="Leadgen ID">{lead.meta_leadgen_id}</DetailRow>
            <DetailRow label="Campaign ID">{lead.campaign_id}</DetailRow>
            <DetailRow label="Ad ID">{lead.ad_id}</DetailRow>
            <DetailRow label="Form ID">{lead.form_id}</DetailRow>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Fields Data</CardTitle>
        </CardHeader>
        <CardContent>
          {responses.length === 0 ? (
            <p className="tw:text-muted-foreground">
              No additional Fields Data.
            </p>
          ) : (
            <div className="tw:grid tw:grid-cols-1 tw:gap-5">
              {responses.map((response, index) => (
                <DetailRow
                  key={`${response.name}-${index}`}
                  label={response.name}
                >
                  {response.value}
                </DetailRow>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default LeadOverview;
